export default {
  data: function data() {
    return {
      options: {
        dataName: "",
        tooltips: {
          intersect: false,
          callbacks: {
            afterLabel: this.afterLabel
          }
        }
      }
    };
  },
  methods: {
    afterLabel: function afterLabel(tooltipItem) {
      if (!this.dataName) {
        console.error("dataName is empty");
      }

      var selectedSeries = this.spec[this.dataName][tooltipItem.datasetIndex];
      var point = selectedSeries.points.find(function (point) {
        return point.x == tooltipItem.xLabel;
      });
      var tooltip = point ? point.tooltip : null;

      if (tooltip) {
        return tooltip;
      }
    }
  }
};